import React, { Fragment } from 'react'

import { Heading } from '@myxplor/ui'
import { FormDate, FormDisplayErrors } from '@myxplor/forms'

import { startOfWeek, dayFormat, endOfWeek, weekStartFormatted } from '../../week'
import { fileNameWithDate } from '../../io/download-csv'

import ReportForm from '../views/form'
import { afterCCSStarted } from './helpers'

const apiEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/services/${gov_id}/reports/ccs-events-management`

const onSubmit = ({ gov_id }) => ({ remote_request }) => payload =>
  remote_request.submit({
    url: `${apiEndPoint({ gov_id })}?start_date=${payload.start_date}&end_date=${payload.end_date}`,
    method: 'GET',
    fileName: fileNameWithDate('CCS Events Management Report'),
  })

const validate = ({ start_date, end_date }) =>
  !!start_date && !!end_date && afterCCSStarted({ week_start_date: start_date })

const FormFields = ({ values, errors, onChange, valid }) => (
  <fieldset>
    <Heading small>CCS Events Management Report</Heading>
    <div className="reportForm--dateRange">
      <div className="reportForm--dateStartToEnd">
        <FormDate
          name="start_date"
          label="Start Date"
          value={values.start_date}
          errors={errors.start_date}
          onChange={onChange}
          required
          today
        />

        <FormDate
          name="end_date"
          label="End Date"
          value={values.end_date}
          errors={errors.end_date}
          onChange={onChange}
          required
          today
        />
      </div>
      
      <div className="reportForm--noHintPadding">
        {valid ? (
          <Fragment>
          This will generate a{' '}
            <abbr title="CSV files can be opened in any spreadsheet program">CSV</abbr> report of your
            CCS Events Management from {weekStartFormatted(values.start_date, true)}, to {weekStartFormatted(values.end_date, true)}.
          </Fragment>
        ) : (
          <FormDisplayErrors
            errors={'You can only create a CCS Events Management report from the 2nd July 2018 until now.'}
          />
        )}
      </div>
      
    </div>
  </fieldset>
)

export const ReportCCSEventsManagement = ({ gov_id, resetCurrentReport }) => (
  <ReportForm
    formOptions={{
      validate: validate,
      defaultValues: {
        start_date: dayFormat(startOfWeek()),
        end_date: dayFormat(endOfWeek()),
      },
    }}
    name="CCS Payments Report"
    fieldsComponent={FormFields}
    resetCurrentReport={resetCurrentReport}
    onSubmit={onSubmit({ gov_id })}
  />
)



// WEBPACK FOOTER //
// ./src/reports/reports/ccs-events-management.jsx